import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PaymentAccounts from "./../../Payment/PaymentAccounts";

export default function FiqhPayment() {
  return (
    <div>
      <section className="mb-10" id="send-money">
        <div>
          <p className=" mt-3">
            নিচের যে কোন নাম্বারে টাকা পাঠান (
            <span className="text-red-500 font-bold"> Send Money </span>)
          </p>
          <p className="">
            <FontAwesomeIcon
              className="text-slate-500 me-1"
              icon={"fa-solid fa-copy"}
            />{" "}
            একাউন্ট নাম্বার কপি করতে নাম্বারের উপর ক্লিক করুন।
          </p>

          <p className="">
            <strong className="text-red-600">দোকান থেকে টাকা না পাঠিয়ে </strong>{" "}
            নিজের/বাড়ির কারো নাম্বার থেকে পাঠান, তাহলে টাকাটা গেল কিনা, ঠিক
            নাম্বারে গেল কিনা নিশ্চিত হতে পারবেন।{" "}
          </p>
          <p className="mt-1 mb-5">
            <FontAwesomeIcon className="text-blue-500" icon={"image"} /> সম্ভব
            হলে টাকা পাঠানোর পর{" "}
            <strong className="text-blue-600">
              স্ক্রিনশট/মানি রিসিটের ছবি
            </strong>{" "}
            তুলুন।{" "}
          </p>
          {/* <p className='mb-5'><FontAwesomeIcon className='text-red-500' icon={'ban'}/> টাকা পাঠানোর এই নাম্বারগুলোতে <strong className='text-red-600'>কল করবেন না</strong> । যে কোন প্রয়োজনে আমাদের সাথে <a target="_blank" href='https://m.me/alharamain.ac' className='bg-sky-300 px-1 rounded-sm'>মেসেঞ্জারে</a>/<a target="_blank" href='https://wa.me/+966578621278' className='bg-lime-400 px-1 rounded-sm'>হোয়াটসঅ্যাপে</a>/<a target="_blank" href='https://t.me/+966578621278' className='bg-blue-400 px-1 rounded-sm'>টেলিগ্রামে</a> যোগাযোগ করুন।</p> */}

          <PaymentAccounts />
        </div>
      </section>
    </div>
  );
}
